import React from 'react';
import noResultImage from '../../assets/images/no-result-found.svg';
import "./emptyState.style.scss";

const EmptyState: React.FC = () => {
    return (
        <div className="WOM-empty-state">
            <div className="empty-state">
                <h3>Sorry, No result found !</h3>
                <img src={noResultImage} alt="nothing found"/>
            </div>
        </div>
    )
}

export default EmptyState;